import { Entity } from '../entity.js';
import { EFFECT_TYPES } from '../combat/statusEffects.js';
import { isInAbilityCircle, isWithinAbilityRange } from '../combat/abilityArea.js';

export const JAX_RELENTLESS_MAX_STACKS = 8;
export const JAX_RELENTLESS_AS_PER_STACK = 0.045;
export const JAX_RELENTLESS_DURATION = 2.5;

export function createJax(id = 'jax-1', team = 'blue', x = 300, y = 1300) {
  const jax = new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 580,
    maxMp: 280,
    ad: 69,
    ap: 0,
    armor: 36,
    mr: 32,
    ms: 350,
    attackRange: 125,
    attackSpeed: 0.638,
    name: 'Jax',
    radius: 20
  });
  jax.wEmpowered = false;
  jax.counterStrikeActive = false;
  jax.grandmasterActive = false;
  jax.as = 0.638;
  jax.baseAttackSpeed = jax.as;
  jax.relentlessStacks = 0;
  jax.relentlessTimer = 0;
  return jax;
}

function syncJaxAttackSpeed(jax) {
  const stacks = jax.relentlessStacks || 0;
  jax.as = jax.baseAttackSpeed + stacks * JAX_RELENTLESS_AS_PER_STACK;
}

/** Relentless Assault: consecutive hits stack attack speed. */
export function applyJaxRelentlessAssault(jax) {
  if (!jax || jax.isDead) return 0;
  const prev = jax.relentlessStacks || 0;
  jax.relentlessStacks = Math.min(JAX_RELENTLESS_MAX_STACKS, prev + 1);
  jax.relentlessTimer = JAX_RELENTLESS_DURATION;
  syncJaxAttackSpeed(jax);
  return jax.relentlessStacks;
}

export function tickJaxRelentlessAssault(jax, dt = 0) {
  if (!jax || !(jax.relentlessStacks > 0) || !(dt > 0)) return;
  jax.relentlessTimer = (jax.relentlessTimer || 0) - dt;
  if (jax.relentlessTimer > 0) return;
  jax.relentlessStacks = 0;
  jax.relentlessTimer = 0;
  syncJaxAttackSpeed(jax);
}

export function castJaxQ(caster, target) {
  if (!caster || caster.isDead || !target || target.isDead) return false;
  if (caster.mp < 50) return false;
  if (!isWithinAbilityRange(caster, target, 700, caster)) return false;
  caster.mp -= 50;
  caster.x = target.x;
  caster.y = target.y;
  if (Number.isFinite(target.z)) caster.z = target.z;
  target.takeDamage(60 + caster.ad * 0.6, caster, 'physical');
  applyJaxRelentlessAssault(caster);
  return true;
}

export function castJaxW(caster) {
  if (!caster || caster.isDead || caster.mp < 30) return false;
  caster.mp -= 30;
  caster.wEmpowered = true;
  return true;
}

export function castJaxE(caster, entities = []) {
  if (!caster || caster.isDead || caster.mp < 50) return false;
  caster.mp -= 50;
  caster.counterStrikeActive = true;
  for (const e of entities) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, caster.x, caster.y, 375, caster)) continue;
    e.takeDamage(35 + caster.ad * 0.5, caster, 'physical');
    e.statusManager?.addEffect?.(EFFECT_TYPES.STUN, 1.0, 0, e.tenacity || 0);
  }
  return true;
}

export function castJaxR(caster) {
  if (!caster || caster.isDead || caster.mp < 100) return false;
  caster.mp -= 100;
  caster.grandmasterActive = true;
  caster.ad += 30;
  caster.armor = (caster.armor || 0) + 20;
  caster.mr = (caster.mr || 0) + 20;
  return true;
}
